namespace SP {
    export interface ShippingMethodAddon {
        code: string;
        name: string;
        defaultEnabled: boolean;
        visible: boolean;
        include: boolean;
        type: string;
        scope: string;
    }
}